import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { set_sidebar } from '../../redux/slices/uiSlice';
import { RiMenu5Fill } from 'react-icons/ri';
import { UpdatePlan } from '../UpdatePlan';

const RequireSubscription = () => {
    const dispatch = useDispatch();
    const sidebar = useSelector((state) => state.ui.sidebar);
    return (
        <div className={`${sidebar ? "lg:pl-[230px]" : "pl-0"} relative h-[100vh] overflow-y-hidden flex flex-col justify-center bg-base-bg items-center px-4`}>
            {
                !sidebar &&
                <button
                    onClick={() => {
                        dispatch(set_sidebar(true))
                    }}
                    type="button"
                    className='mr-5 h-[40px] w-[40px] rounded-full absolute top-5 left-5 transition-all hover:bg-primary/5 flex items-center justify-center'
                >
                    <RiMenu5Fill className='text-t-light text-xl' />
                </button>
            }
            {
                <UpdatePlan />
            }
        </div>
    )
}

export default RequireSubscription